// extracted by mini-css-extract-plugin
export default {"overlay":"Pw-z","bodyOpen":"Qw-z","content":"Rw-z","header":"Sw-z","close":"Tw-z","closeNoHeading":"Uw-z"};